export default __webpack_public_path__ + "static/team-lauren-161749e0e1f343cd28ff217d88553744.png";